import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

import buildPath from '../utilities/buildPath';

type Props = {
  userWorkflowId: string;
};
const PATH_TEMPLATE = '/workflows/user-workflows/{userWorkflowId}/contextMap';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

const getUserWorkflowContext = async ({ userWorkflowId }: Props): Promise<THIS_API['response']> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { userWorkflowId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getUserWorkflowContext;
